import { IonSpinner } from '@ionic/react';
import React from 'react';

import './Spinner.scss';
import { SpinnerProps } from './types';

const Spinner: React.FC<SpinnerProps> = ({ fullscreen, color = 'primary', transparent }) => {
  const containerClass = fullscreen
    ? `spinner__container${transparent ? ' spinner__container--transparent' : ''}`
    : undefined;

  return (
    <div className="spinner">
      <div className={containerClass}>
        <IonSpinner name='circular' color={color} />
      </div>
    </div>
  );
};

export default Spinner;
